import { Component, inject, Input } from "@angular/core";
import { ControlContainer, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { FormFieldComponent } from "@odx/angular/components/form-field";

@Component({
  selector: "app-opportunity-link-form-field",
  imports: [FormFieldComponent, ReactiveFormsModule, UiKitModule],
  templateUrl: "./opportunity-link-form-field.component.html",
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (): ControlContainer => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  standalone: true,
})
export class OpportunityLinkFormFieldComponent {
  @Input() isReadonly!: boolean;
  @Input() required!: boolean;
}
